import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.invoiceStatusSection.title',
    defaultMessage: 'Status',
    description: 'Title of the status section',
  },
  overview: {
    isConfirmed: {
      id: 'pages.invoiceStatusSection.overview.isConfirmed',
      defaultMessage: 'Confirmed',
      description: 'Title of the invoicing is confirmed status in the status section',
    },
    isPaid: {
      id: 'pages.invoiceStatusSection.overview.isPaid',
      defaultMessage: 'Paid',
      description: 'Title of the invoicing is paid status in the status section',
    },
    paidAt: {
      id: 'pages.invoiceStatusSection.overview.paidAt',
      defaultMessage: 'Paid at',
      description: 'Title of the invoicing paid at status in the status section',
    },
    billedAt: {
      id: 'pages.invoiceStatusSection.overview.billedAt',
      defaultMessage: 'Billed at',
      description: 'Title of the invoicing billed at status in the status section',
    },
  },
  status: {
    yes: {
      id: 'pages.invoiceStatusSection.status.yes',
      defaultMessage: 'Yes',
      description: 'Title of the in yes status value in the status section',
    },
    no: {
      id: 'pages.invoiceStatusSection.status.no',
      defaultMessage: 'No',
      description: 'Title of the no status value in the status section',
    },
  },
};

export default defineMessages(translations);
